import React, { PureComponent } from 'react';
import SearchHighlight from '../common/SearchHighlight';

class CanslimSearch extends PureComponent {
  render() {
    return (
      <div className="list-filter">
        <SearchHighlight typeSearch={'highlight'} />
      </div>
    );
  }
}

export default CanslimSearch;
